// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Collocation({ fullData }) {
  return (
    <>
      <div className="metatitle"><span>Collocation</span></div>
      <div className="collocation--list">
        <div className="collocation--list__container">
          <h1>Collocation instruments</h1>
          {fullData.map((elem) => (
            <div key={elem.marker}>
              {(elem.collocation_instruments.length === 0)
              && (
                <div key={elem.iers_domes} className="collocation--list__container--card">
                  <p key={elem.name} className="no_collocation">No Collocation instruments</p>
                </div>
              )}
              {(elem.collocation_instruments.length !== 0)
              && elem.collocation_instruments.map((collocation) => (
                <div key={Object.keys(elem.marker_long_name)} className="collocation--list__container--card">
                  <p key={collocation.type}><span className="name"><b>type: </b></span>{collocation.type}</p>
                  <p key={collocation.status}><span className="name"><b>status: </b></span>{collocation.status}</p>
                  <p key={collocation.date_from}><span className="name"><b>date from: </b></span>{collocation.date_from}</p>
                  <p key={collocation.date_to}><span className="name"><b>date to: </b></span>{collocation.date_to === null ? '' : collocation.date_to}</p>
                  <p key={collocation.comment}><span className="name"><b>Comment: </b></span>{collocation.comment}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="collocation--list__container">
          <h1>Local ties</h1>
          {fullData.map((elem) => (
            <div key={elem.marker}>
              {(elem.local_ties.length === 0)
              && (
                <div key={elem.iers_domes} className="collocation--list__container--card">
                  <p key={elem.name} className="no_collocation">No Local ties</p>
                </div>
              )}
              {(elem.local_ties.length !== 0)
              && elem.local_ties.map((localties) => (
                <div key={Object.keys(elem.marker_long_name)} className="collocation--list__container--card">
                  <p key={localties.name}><span className="name"><b>Name : </b></span>{localties.name}</p>
                  <p key={localties.usage}><span className="name"><b>Usage : </b></span>{localties.usage}</p>
                  <p key={localties.cdp_num}><span className="name"><b>Cpd number : </b></span>{localties.cpd_num}</p>
                  <p key={localties.dx}><span className="name"><b>Dx : </b></span>{localties.dx}</p>
                  <p key={localties.dy}><span className="name"><b>Dy : </b></span>{localties.dy}</p>
                  <p key={localties.dz}><span className="name"><b>Dz : </b></span>{localties.dz}</p>
                  <p key={localties.accuracy}><span className="name"><b>Accuracy : </b></span>{localties.accuracy}</p>
                  <p key={localties.survey_method}><span className="name"><b>Survey method : </b></span>{localties.survey_method}</p>
                  <p key={localties.date_at}><span className="name"><b>Date mesure : </b></span>{localties.date_at}</p>
                  <p key={localties.comment}><span className="name"><b>Comment : </b></span>{localties.comment}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="collocation--list__container">
          <h1>Local ongoing conditions</h1>
          {fullData.map((elem) => (
            <div key={elem.marker}>
              {(elem.conditions.length === 0)
              && (
                <div key={elem.iers_domes} className="collocation--list__container--card">
                  <p key={elem.name} className="no_collocation">No Local ongoing conditions</p>
                </div>
              )}
              {(elem.conditions.length !== 0)
              && elem.conditions.map((condition) => (
                <div key={Object.keys(elem.marker_long_name)} className="collocation--list__container--card">
                  <p key={condition.effect.type}><span className="name"><b>effect type: </b></span>{condition.effect.type}</p>
                  <p key={condition.degradation}><span className="name"><b>degradation: </b></span>{condition.degradation}</p>
                  <p key={condition.date_from}><span className="name"><b>date from: </b></span>{condition.date_from}</p>
                  <p key={condition.date_to}><span className="name"><b>date to: </b></span>{condition.date_to === null ? '' : condition.date_to}</p>
                  <p key={condition.comments}><span className="name"><b>Comments: </b></span>{condition.comments}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

Collocation.propTypes = {
  fullData: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
};

export default Collocation;
